// CakeList.js
import React from 'react';
import axiosInstance from '../../../utils/axiosInstance';
import { Link } from 'react-router-dom';

const CakeList = ({ cakes }) => {
  return (

    <>
    
    {/* <div className="container mx-auto px-4 sm:px-8 md:px-12 lg:px-20 xl:px-24 2xl:px-32 py-8">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8">
        {cakes.map((cake) => (
          <div key={cake.id} className="p-4 transition-transform duration-300 transform hover:scale-105">
                        <Link to={`/product/${cake._id}`} className="block">

            <div className="max-w-full rounded overflow-hidden shadow-lg bg-white">
              <img
                className="w-full h-36 object-cover rounded-t-lg"
                src={`${axiosInstance.defaults.baseURL}/${cake.image}`}
                alt={cake.name}
              />
              <div className="px-6 py-4">
                <div className="font-roboto font-bold text-sm md:text-xl mb-2 text-gray-800">{cake.name}</div>
                <p className="text-red-500 text-sm md:text-xl mb-2">Price: NPR {cake.price}</p>
              </div>
              
            </div>
            </Link >
          </div>
        ))}
      </div>


    </div> */}

<div className="grid md:mx-36 grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 md:gap-4  gap-2 mx-2 mt-4">
{cakes.map((cake) => (
  <div key={cake.id} className="   shadow transition-transform transform hover:scale-105 bg-white">
    <Link to={`/product/${cake._id}`} className="block">
      <div className="relative md:h-36 lg:h-48 h-36 overflow-hidden ">
        <img width={600} height={600}
          className="lg:w-full lg:h-full h-32 md:h-36 object-cover"
          src={`${axiosInstance.defaults.baseURL}/${cake.image}`}
          alt={cake.name}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black opacity-40"> </div>
      </div>
      </Link>
      <div className="mt-2 p-2">
        <p className="text-lg font-heading text-black mb-2">{cake.name}</p>
        <p className="text-red-500 text-sm font-semibold">NPR:{cake.price}</p>
      </div>
    
  </div>
))}
</div>
    </>
  );
};

export default CakeList;
